import React from "react";
import "./Hero.css";
import Header from "../Header/Header";
import hero_image from "../../assets/hero_image.png";
import hero_image_back from "../../assets/hero_image_back.png";
import heart from "../../assets/heart.png";
import calories from "../../assets/calories.png";
import { motion } from "framer-motion";
import { Link } from "react-scroll";
import Numbercounter from "number-counter";
const Hero = () => {
  const transition = { type: "spring", duration: 3 };
  const mobile = window.innerWidth <= 768 ? true : false;
  return (
   
    <div className="hero" id="home">
       <div className="blur hero-blur"></div>
      <div className="left-h">
        <Header />
        <div className="the-best-ad">
          <motion.div
           initial={{ left: mobile ? "165px" : "238px" }}
            whileInView={{ left: "8px" }}
            transition={{ ...transition, type: "tween" }}
          ></motion.div>
          <span>the best fitness club in the town.</span>
        </div>
        {/* Hero Heading */}
        <div className="hero-text">
          <div>
            <span className="stroke-text">Shape </span>
            <span>Your</span>
          </div>
          <div>
            <span>Ideal Body</span>
          </div>
          <div>
            <span>
              In here we will help you to shape and build your ideal body and
              live up your life to fullest
            </span>
          </div>
        </div>
        {/* Figures */}
        <div className="figures">
          <div>
            <span>
              <Numbercounter end={140} start={100} delay="4" preFix="+" />
            </span>
            <span>Expert Coaches</span>
          </div>
          <div>
            <span>
              <Numbercounter end={978} start={800} delay="4" preFix="+" />
            </span>
            <span>Members joined</span>
          </div>
          <div>
            <span>
              <Numbercounter end={50} start={40} delay="4" preFix="+" />
            </span>
            <span>fitness programs</span>
          </div>
        </div>
        {/* Hero Buttons */}
        <div className="hero-buttons">
          <button  className="btn" onClick={()=> window.scrollTo({behavior:'smooth'})}>
            <Link to="join" spy={true} smooth={true}>
          Get Started</Link></button>
          <button className="btn" onClick={()=> window.scrollTo({behavior:'smooth'})}>
            <Link to="Programs" spy={true} smooth={true}>
            Learn More</Link></button>
        </div>
      </div>
      {/* Right Side */}
      <div className="right-h">
        <button className="btn" onClick={()=> window.scrollTo({behavior:'smooth'})}>
          <Link to="join" spy={true} smooth={true}>
          Join Now</Link></button>
        <motion.div 
        initial={{ right: "-1rem" }}
      whileInView={{ right: "4rem" }}
      transition={transition}
      className="heart-rate">
          <img src={heart} alt="" />
          <span>Heart Rate</span>
          <span>116 bpm</span>
        </motion.div>
        <img src={hero_image} alt="" className="hero-image" />
        <motion.img 
        initial={{ right: "11rem" }}
        whileInView={{ right: "23rem" }}
        transition={{...transition, type: "tween"}}
         src={hero_image_back} alt="" className="hero-image-back" />
        {/*"calories"*/}
        <motion.div 
        initial={{ right: "37rem" }}
        whileInView={{ right: "26rem" }}
        transition={{...transition,type: "tween"}}
        className="calories">
          <img src={calories} alt="" />
          <div>
            <span>CaloriesBurned</span>
            <span>220 kcal</span>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
